import React from 'react'
import type { Icon } from 'shared/utils'
import { colors } from 'shared/assets/styles'

export const CircleShareIcon = (props: Icon) => {
    const {
        color = colors.bbqBrown,
        size = 24,
        className = 'circleShareIcon',
        ...otherProps
    } = props
    return (
        <svg
            width={size}
            height={size}
            className={className}
            viewBox="0 0 57 56"
            fill="none"
            {...otherProps}>
            <rect
                x="1"
                y="0.5"
                width="55"
                height="55"
                rx="27.5"
                stroke="#CBBDB9"
            />
            <g clip-path="url(#clip0_7185_28219)">
                <path
                    d="M29.4235 18.5156C29.1803 18.586 28.5787 19.1812 28.4251 19.3796C27.0171 21.1716 26.1595 22.0868 24.7515 23.8724C24.2971 24.4484 23.6443 25.6324 24.2907 26.33C24.7963 26.8804 25.5707 26.714 26.4155 26.6692L27.2987 26.7012C27.2859 29.4404 27.4267 29.146 27.4907 32.122C27.5099 33.0372 28.3227 33.7348 29.2379 33.6132L29.9419 33.5172C30.7355 33.4084 31.3115 32.7108 31.2667 31.9108C31.1259 29.1972 31.1515 29.4212 31.1643 26.8356C31.6379 26.81 32.7963 26.906 33.2699 26.8868C33.8139 26.8612 34.6459 26.522 34.6203 25.6004C34.5883 24.4548 31.6763 20.7876 30.5691 19.1556C30.3067 18.7652 29.8715 18.3748 29.4235 18.5092L29.4235 18.5156Z"
                    fill={color}
                />
                <path
                    d="M39.7065 31.1295H39.2521C38.8873 31.1103 38.1385 31.4047 38.1385 31.7695C38.1385 34.8799 38.1385 34.2527 38.1513 34.5535C38.1641 35.1423 38.3241 36.5375 37.5497 36.7295L37.0249 36.7871C36.6025 36.8959 36.1737 36.8447 35.7385 36.8639C35.0025 36.8959 34.2601 36.8447 33.5241 36.8639C32.8649 36.8831 21.5945 37.0239 20.9481 36.8767C20.3273 36.7359 20.5257 36.0255 20.5257 35.4751C20.5257 34.9887 20.5257 35.3791 20.5129 31.7503C20.5129 31.3791 19.6681 31.0591 19.3353 31.0591C19.0153 31.0591 17.7993 31.3919 17.8057 31.7695C17.8441 33.9775 17.7801 37.2223 17.8505 38.0863C17.9593 39.4559 18.8745 39.7631 19.6745 39.7631C25.4601 39.7631 29.6201 40.0959 34.7337 39.9039C35.8985 39.8591 36.6665 39.8207 37.8249 39.7183C38.6697 39.6479 40.3529 39.7951 40.7241 38.7583C40.8393 38.4383 40.8393 38.0927 40.8393 37.7535C40.8393 36.4479 40.8393 35.0591 40.8393 31.7695C40.8393 31.4239 40.0457 31.1423 39.7001 31.1231L39.7065 31.1295Z"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id="clip0_7185_28219">
                    <rect
                        width={size}
                        height={size}
                        fill="none"
                        transform="translate(12.5 12)"
                    />
                </clipPath>
            </defs>
        </svg>
    )
}
